import { render, staticRenderFns } from "./BFCMBadge.vue?vue&type=template&id=194d63a2&scoped=true"
import script from "./BFCMBadge.vue?vue&type=script&lang=js"
export * from "./BFCMBadge.vue?vue&type=script&lang=js"
import style0 from "./BFCMBadge.vue?vue&type=style&index=0&id=194d63a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194d63a2",
  null
  
)

export default component.exports